import { render } from "./Oportunities.vue?vue&type=template&id=66f43c24&scoped=true"
import script from "./Oportunities.vue?vue&type=script&lang=js"
export * from "./Oportunities.vue?vue&type=script&lang=js"

import "./Oportunities.vue?vue&type=style&index=0&id=66f43c24&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f43c24"]])

export default __exports__